import RangedatePricker from './RangedatePicker';

export default RangedatePricker;


// WEBPACK FOOTER //
// ./resources/assets/js/components/RangedatePicker/index.js